export default {
  '002.png': '002.png',
  '003.png': '003.png',
  '004.png': '004.png',
  '007.png': '007.png',
  '011.png': '011.png',
  '012.png': '012.png',
  '020.png': '020.png',
  '023.png': '023.png',
  '027.png': '027.png',
  '031.png': '031.png',
  '032.png': '032.png',
  '034.png': '034.png',
  '035.png': '035.png',
  '037.png': '037.png',
  '039.png': '039.png',
  '045.png': '045.png',
  '048.png': '048.png',
  '050.png': '050.png',
  '064.png': '064.png',
  '071.png': '071.png',
  '081.png': '081.png',
  '088.png': '088.png',
  '089.png': '089.png',
  '090.png': '090.png',
  'empty.png': 'empty.png',
}
